import React, {Suspense} from 'react';
import {useSelector} from 'react-redux';
import {Route, Switch, Redirect} from 'react-router-dom';

import RoutesConstant from '../constants/routes';
import PageContainer from '../containers/PageContainer/PageContainer';
import withProtectRouteHoc from '../hoc/withProtectRoute';
import NotFound from '../pages/NotFound/NotFound';
import {createNavWithPermissions} from '../utils/permission';

import {getPagesRoutes} from './pages';

const PageRouter = (props) => {
  const user = useSelector((state) => state.auth);
  const permissions = useSelector((state) => state.permissions);
  const PageRoutes = getPagesRoutes(user, permissions);
  const finalNavBarList = createNavWithPermissions(PageRoutes);
  const NotFoundCustom = () => <NotFound permissions={!permissions.read} />;
  return (
    <Suspense fallback={<div> Loading... </div>}>
      {!permissions.read && <NotFoundCustom />}
      <Switch>
        {PageRoutes.map((page) => {
          const Component = withProtectRouteHoc({
            PageContainer,
            redirect: {
              HOME: RoutesConstant.HOME,
              LOGIN: RoutesConstant.LOGIN,
            },
            Component: page.component,
            componentProps: page.componentProps,
            isProtected: page.isProtected,
            showRoute: page.showRoute || false,
            finalNavBarList: finalNavBarList,
          });
          return <Route {...props} exact component={Component} path={page.path} key={page.path} />;
        })}
        <Route path="/" exact component={() => <Redirect to={RoutesConstant.FAILED_ORDERS} />} />
        <Route path="/*" exact component={NotFoundCustom} key={'/*'} />
      </Switch>
    </Suspense>
  );
};
export default PageRouter;
